export default "__VITE_ASSET__BFKxPjDn__"